import "./table.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import Popover from '@mui/material/Popover';
import { useState } from "react";
import SchoolHoverCard from "../schoolhovercard/SchoolHoverCard";
const rows = [{
  id: 12,
  school: 'PS Girls HS, Birmaharajpur',
  // district: 'Rayagada',
  // block: 'block',
  exercise_usage: 3433,
  video_usage: 32,
},
{
  id: 13,
  school: 'PS Girls HS, Birmaharajpur',
  district: 'Rayagada',
  block: 'block',
  exercise_usage: 3433,
  video_usage: 32,
},
{
  id: 14,
  school: 'PS Girls HS, Birmaharajpur',
  district: 'Rayagada',
  block: 'block',
  exercise_usage: 3433,
  video_usage: 32,
},
{
  id: 15,
  school: 'PS Girls HS, Birmaharajpur',
  district: 'Rayagada',
  block: 'block',
  exercise_usage: 3433,
  video_usage: 32,
},
];

const TopSchoolsTable = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverSchoolId, setPopoverSchoolId] = useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setPopoverSchoolId(event.currentTarget.dataset.id)
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
    return (
    <TableContainer component={Paper} className="tableContainer" sx={{boxShadow: '2px 4px 10px 1px rgba(201, 201, 201, 0.47)'}}>
      <div className="tableTitle"> Top Schools</div>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <SchoolHoverCard schoolId={popoverSchoolId}/>
      </Popover>
      <Table sx={{ minWidth: 650 }} aria-label="top schools">
        <TableHead>
          <TableRow>
            <TableCell>School Id</TableCell>
            <TableCell>School</TableCell>
            {rows && rows.length>0 && rows[0].district && <TableCell>District</TableCell>}
            {rows && rows.length>0 && rows[0].block && <TableCell>Block</TableCell>}
            <TableCell>Video Usage</TableCell>
            <TableCell>Exercise Usage</TableCell>
            <TableCell>Average Daily Usage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows && rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell ><Link  to={`/school/${row.id}`}><span className="text-[#8884d8] hover:underline">{row.id}</span></Link></TableCell>
              <TableCell ><Link data-id={row.id} onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} to={`/school/${row.id}`}><span className="text-[#8884d8] hover:underline">{row.school}</span></Link></TableCell>
              {rows.length>0 && rows[0].district &&<TableCell>{row.district}</TableCell>}
              {rows.length>0 && rows[0].block && <TableCell>{row.block}</TableCell>}
              <TableCell>{row.video_usage} min</TableCell>
              <TableCell>{row.exercise_usage} min</TableCell>
              <TableCell> 
                {row.average_daily_usage}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TopSchoolsTable;
